import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ValidationQueueNSwagMigrationService } from '../../api/migration/validation-queue-nswag-migration.service';
import {
    sendAIVendorFeedback,
    sendAIVendorFeedbackFailure,
    sendAIVendorFeedbackSuccess
} from '../actions/validation-queue.actions';

@Injectable()
export class ValQueueEffects {
    constructor(private readonly _actions$: Actions, private readonly _valQueueService: ValidationQueueNSwagMigrationService) {}

    sendAIVendorFeedback$ = createEffect(() =>
        this._actions$.pipe(
            ofType(sendAIVendorFeedback),
            switchMap((action) => {
                if (!action.aiVendorFeedback.contractId) {
                    return of(sendAIVendorFeedbackSuccess());
                }
                return this._valQueueService.sendAIVendorFeedback(action.aiVendorFeedback).pipe(
                    map(() => sendAIVendorFeedbackSuccess()),
                    catchError((error) => of(sendAIVendorFeedbackFailure({ error: error })))
                );
            })
        )
    );
}
